import React from 'react';
import { grey, red } from '@mui/material/colors';
import { ArrowDropDown } from '@mui/icons-material';
import { useFormContext, useWatch } from 'react-hook-form';
import { ListingForm } from 'components/shared/TableListing';
import { IconButton, Stack, Typography } from '@mui/material';
import { ActionsMenu } from 'components/shared/Menu/ActionsMenu';
import { AttributeFieldProps, StagesFormValues } from 'modules/stages/types';

import { AttributeRequiredIndicator } from './AttributeRequiredIndicator';

export const AttributeRequiredNode = ({ attributeIndex, rowIndex, prefix, disabled }: AttributeFieldProps) => {
  const { control, setValue } = useFormContext<ListingForm<StagesFormValues>>();
  const isRequired = useWatch({
    control,
    name: `bodyFields.${rowIndex}.${prefix}.${attributeIndex}.isRequired`,
  });

  return (
    <Stack direction="row" alignItems="center">
      <Stack alignItems="center" justifyContent="center" mr="0.5rem">
        <AttributeRequiredIndicator color={isRequired ? red[500] : grey[200]} />
      </Stack>

      <Typography variant="caption">{isRequired ? 'Required' : 'Optional'}</Typography>

      <ActionsMenu
        renderTrigger={({ onClick }) => (
          <IconButton onClick={onClick} size="small">
            <ArrowDropDown sx={{ color: 'black' }} fontSize="small" />
          </IconButton>
        )}
        config={[
          {
            disabled,
            color: grey[500],
            label: 'Optional',
            action: () => setValue(`bodyFields.${rowIndex}.${prefix}.${attributeIndex}.isRequired`, true),
            icon: <AttributeRequiredIndicator color={grey[200]} />,
          },
          {
            disabled,
            color: red[500],
            label: 'Required',
            action: () => setValue(`bodyFields.${rowIndex}.${prefix}.${attributeIndex}.isRequired`, false),
            icon: <AttributeRequiredIndicator color={red[500]} />,
          },
        ]}
      />
    </Stack>
  );
};
